export default [
  // {
  //   name: "butterflyTexture",
  //   type: "texture",
  //   path: "textures/butterfly.png",
  // },
  {
    name: "samirBasicTurn",
    type: "fbxModel",
    path: "models/moveai.fbx",
  },
  {
    name: "samirBasicTurn2",
    type: "fbxModel",
    path: "models/samirBasicTurn3.fbx",
  },
  // {
  //   name: "butterflyTexture2",
  //   type: "texture",
  //   path: "textures/butterfly2.png",
  // },
  // {
  //   name: "butterflyTexture3",
  //   type: "texture",
  //   path: "textures/butterfly3.png",
  // },
  // {
  //   name: "planeTexture",
  //   type: "texture",
  //   path: "textures/grey.png",
  // },
  // {
  //   name: "forestFloor",
  //   type: "glbModel",
  //   path: "forestbase.glb",
  // },
];
